<template>
  <div class="content flex my-4">
    <div class="auth-form mx-auto my-auto">
      <div class="card">
        <div class="card-body">
          <h1 class="heading-bigger text-center mb-4">{{ $t('activationAccount.confirmationActivation') }}</h1>
          <div class="text-center mt-3 flex flex-column">
            <f-alert
              v-if="activationConfirmed"
              theme="success"
              centered
              visible>
              {{ $t('activationAccount.thankYouForActivation') }}
            </f-alert>

            <f-button
              v-if="!activationConfirmed"
              type="submit"
              theme="primary"
              big
              withArrow
              @click.prevent="activateAccount">
              {{ $t('activationAccount.activeAccountButton') }}
            </f-button>

            <div
              v-if="!isAdviser"
              class="text-center mt-4">
              <router-link
                to="/logowanie"
                class="lnk lnk-big lnk-big-blue">
                {{ $t('ui.backToLoginPage') }}
              </router-link>
            </div>
            <div
              v-if="isAdviser"
              class="text-center mt-4">
              <a
                :href="siteDomain"
                rel="nofollow noopener noreferrer"
                class="lnk lnk-big lnk-big-blue">
                {{ $t('ui.backToGeneralPage') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'activate-account',
  computed: {
    ...mapGetters({
      siteDomain: 'getSideDomain'
    }),
    activationToken () {
      if (this.$route.params && this.$route.params.token) {
        return { token: this.$route.params.token };
      }

      return '';
    },
    isAdviser () {
      if (!this.$route.meta || !this.$route.meta.isAdviser) {
        return false;
      }

      return !!this.$route.meta.isAdviser;
    }
  },
  data () {
    return {
      activationConfirmed: false
    }
  },
  mounted () {
  },
  methods: {
    activateAccount () {
      let endpointUrl = this.isAdviser ? '/api/auth/activate-adviser' : '/api/auth/activate';

      this.$http.post(endpointUrl, this.activationToken).then(() => {
        if (this.isAdviser) {
          Vue.set(this, 'activationConfirmed', true);
          return;
        }
        this.$router.push('/logowanie/konto-aktywne');
      }).catch((error) => {
        console.log(error);
      });
    }
  }
};
</script>
